// src/modules/f1impostor/actionTypes.js
export const START_F1_IMPOSTOR_GAME_COMPLETED = "f1Impostor/startGameCompleted";
export const VALIDATE_F1_IMPOSTOR_COMPLETED = "f1Impostor/validateCompleted";
export const GET_F1_IMPOSTOR_STATUS_COMPLETED = "f1Impostor/getStatusCompleted";
